type BaseAttachment = {
  fileName?: string | null;
  fileType?: string | null;
  isAttachmentDeleted?: boolean | null;
  isAttachmentExpired?: boolean | null;
};

type FilterAttachmentsResult<T> = {
  imageAttachments: Array<T>;
  nonImageAttachments: Array<T>;
  hasEveryAttachmentExpired: boolean;
  hasSomeDeletedAttachments: boolean;
};

/**
 * Filters attachments into image and non-image categories
 * @param attachments - Array of attachments to filter
 * @param imageFileType - String identifier for image file types (defaults to 'image')
 * @returns Object containing filtered arrays and metadata flags
 */
export default function filterAttachments<T extends BaseAttachment>(
  attachments: Array<T>,
  imageFileType = 'image',
): FilterAttachmentsResult<T> {
  const imageAttachments: Array<T> = [];
  const nonImageAttachments: Array<T> = [];
  let hasSomeDeletedAttachments = false;
  let hasEveryAttachmentExpired = true;

  attachments.forEach((attachment) => {
    const { fileName = '', fileType = '', isAttachmentDeleted, isAttachmentExpired } = attachment;

    if (isAttachmentDeleted) {
      hasSomeDeletedAttachments = true;
      return;
    }

    if (!isAttachmentExpired) {
      hasEveryAttachmentExpired = false;
    }

    if ((fileName as string) && fileName?.includes('unknown')) return;

    if ((fileType as string) && fileType?.includes(imageFileType)) {
      return imageAttachments.push(attachment);
    }

    return nonImageAttachments.push(attachment);
  });

  return {
    imageAttachments,
    nonImageAttachments,
    hasEveryAttachmentExpired,
    hasSomeDeletedAttachments,
  };
}
